/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of DateTimeField.
 * @typedef {Object} DateTimeFieldType
 *
 * @typedef {QuestionFormFieldType & DateTimeFieldType} DateTimeFieldExtendType
 */

/**
 * Represents a date time form field.
 * @class
 */
export class DateTimeField extends QuestionFormField {}
